import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiPutRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { toContentBase64, toContentBinaryContent } from "src/utils/utils";
import KmPageTitle from "src/components/layout/KmPageTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const NewsForm = ({ enableGlobalLoader, disableGlobalLoader, setLogoutUser, ...rest }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [news, setNews] = useState(null);
  const editMode = rest.kmaction === "edit";

  let pageTitle = rest.kmaction === "new" ? "Nowy artykuł" : "Edycja artykułu";

  useEffect(() => {
    if (editMode) {
      enableGlobalLoader();
      apiGetByIdRequest(apiEndpoints.getNewsEditDetails.path, entryId, true)
        .then((data) => {
          disableGlobalLoader();
          setNews(data);
        })
        .catch((error) => {
          disableGlobalLoader();
        });
    }
    return () => {};
  }, []);

  const onSubmit = (
    formValues,
    content,
    mainImageFile,
    images,
    attachments
  ) => {
    enableGlobalLoader();

    const mainImageFilePromise = toContentBase64(mainImageFile);

    Promise.all([mainImageFilePromise])
      .then((values) => {
        if (editMode) {
          apiPutRequest(
            apiEndpoints.updateNews.path,
            {
              id: entryId,
              title: formValues.title,
              header: formValues.header,
              content: content,
              mainImageFile: values[0]
                ? {
                    fileName: mainImageFile.name,
                    fileData: values[0],
                  }
                : null,
              images: images.map((image) => {
                return {
                  id: (image.dbId) ? image.dbId : null,
                  description: image.name,
                  imageFile: (image.fileData) ? {
                    fileName: image.resName,
                    fileData: image.fileData.data,
                  } : null,
                };
              }),
              attachments: attachments.map((attachment) => {
                return {
                  id: (attachment.dbId) ? attachment.dbId : null,
                  type: attachment.attachmentType,
                  description: attachment.name,
                  attachmentFile:
                    attachment.attachmentType === "file" && attachment.fileData
                      ? {
                          fileName: attachment.resName,
                          fileData: attachment.fileData.data,
                        }
                      : null,
                  urlLabel:
                    attachment.attachmentType === "url" ? attachment.urlLabel : null,
                  urlValue:
                    attachment.attachmentType === "url"
                      ? attachment.url
                      : null,
                };
              }),
            },
            true
          )
            .then((data) => {
              disableGlobalLoader();
              navigate("/aktualnosci/wersjerob");
            })
            .catch((error) => {

              disableGlobalLoader();
              if (error.response && error.response.status === 401) {
                setLogoutUser();
              }
            });
        } else {
          apiPostRequest(
            apiEndpoints.addNews.path,
            {
              title: formValues.title,
              header: formValues.header,
              content: content,
              mainImageFile: values[0]
                ? {
                    fileName: mainImageFile.name,
                    fileData: values[0],
                  }
                : null,
              images: images.map((image) => {
                return {
                  description: image.name,
                  imageFile: {
                    fileName: image.resName,
                    fileData: image.fileData.data,
                  },
                };
              }),
              attachments: attachments.map((attachment) => {
                return {
                  type: attachment.attachmentType,
                  description: attachment.name,
                  attachmentFile:
                    attachment.attachmentType === "file"
                      ? {
                          fileName: attachment.resName,
                          fileData: attachment.fileData.data,
                        }
                      : null,
                  urlLabel:
                    attachment.attachmentType === "url" ? attachment.urlLabel : null,
                  urlValue:
                    attachment.attachmentType === "url"
                      ? attachment.url
                      : null,
                };
              }),
            },
            true
          )
            .then((data) => {
              disableGlobalLoader();
              navigate("/aktualnosci/wersjerob");
             
            })
            .catch((error) => {

              disableGlobalLoader();
              if (error.response && error.response.status === 401) {
                setLogoutUser();
              }
            });
        }
      })
      .catch((err) => {
      });
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>{pageTitle}</KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form onSubmit={onSubmit} news={news} editMode={editMode} />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser())
});

export default connect(null, mapDispatchToProps)(NewsForm);
